import { UserLeave } from "./userLeaves.reducer"

export enum Types {
  GET = "GET_USER_LEAVES",
  GET_SUCCESS = "GET_USER_LEAVES_SUCCESS",
  GET_FAIL = "GET_USER_LEAVES_FAIL",
}

export type Action = GetUserLeavesAction | GetUserLeavesSuccessAction | GetUserLeavesFailAction

export type GetUserLeavesAction = {
  type: Types.GET
  payload: { params: { year: string; uid: string } }
}

export type GetUserLeavesSuccessAction = {
  payload: { data: UserLeave[] | undefined }
  type: Types.GET_SUCCESS
}

export type GetUserLeavesFailAction = {
  payload: { errors: object }
  type: Types.GET_FAIL
}

export function getUserLeaves(params: { year: string; uid: string }): GetUserLeavesAction {
  return {
    type: Types.GET,
    payload: {
      params,
    },
  }
}

export function getUserLeavesSuccess(data: UserLeave[] | undefined): GetUserLeavesSuccessAction {
  return {
    payload: { data },
    type: Types.GET_SUCCESS,
  }
}

export function getUserLeavesFail(errors: object): GetUserLeavesFailAction {
  return {
    payload: { errors },
    type: Types.GET_FAIL,
  }
}
